module.exports = __webpack_public_path__ + "static/media/signup-hero.f60c62d7.png";